export type InpoolLanguage = 'en' | 'de' | 'fr';

export const inpoolLanguages: InpoolLanguage[] = ['en', 'de', 'fr'];
